export enum RecommendationType {
  ADS = "ADS",
  AGEING = "AGEING",
  BASKET = "BASKET",
  BOUGHT_TOGETHER = "FREQUENTLY_BOUGHT_TOGETHER",
  BRANDS = "BRAND",
  CATEGORIES = "CATEGORY",
  FRESHFOOD = "FRESH_FOOD",
  NEW_ARRIVALS = "NEWLY_ON_BOARDED",
  RECOMMENDED_FOR_YOU = "RECOMMENDED_FOR_YOU",
  SEARCH_START_TOPPICKS = "SEARCH_START_TOPPICKS",
  TOPPICKS = "TOP_PICKS",
}

export enum RecommendationVariants {
  RECOMMENDED_FOR_YOU = "RECOMMENDED_FOR_YOU",
  BASKET = "BASKET",
  TOP_PICKS = "TOP_PICKS",
  FREQUENTLY_BOUGHT_TOGETHER = "FREQUENTLY_BOUGHT_TOGETHER",
  FRESH_FOOD = "FRESH_FOOD",
  BRANDS = "brand",
  CATEGORIES = "category",
}

export enum RecommendedType {
  PRODUCT_BASED = "PRODUCT_BASED",
  USER_BASED = "USER_BASED",
  CUSTOM = "CUSTOM",
}

export enum EndPoint {
  recommendation = "/recommendations/",
  search = "/search/document/",
}

export enum WEBVIEW_MESSAGE_TYPE {
  SEE_ALL = "SEE_ALL",
  NAVIGATE_PDP_PAGE = "NAVIGATE_PDP_PAGE",
  REDIRECT_TO_LOGIN = "REDIRECT_TO_LOGIN",
  ADD_TO_BASKET = "ADD_TO_BASKET",
  BASKET_ITEMS = "BASKET_ITEMS",
  CLOSE = "CLOSE",
}

export enum IFRAME_POSTMESSAGE_TYPE {
  SET_HEIGHT = "SET_HEIGHT",
}
